<template>
  <div id="app">
    <div id="app_wrapper" v-if="$store.state.app_is_ready">
      <MainMenu />

      <div id="main_container">
        <MainHeader />

        <div id="main_container_content">
          <router-view />
          <b-modal
            class="modalblur"
            centered
            id="session-modale"
            title="Session expirée"
            no-close-on-esc
            no-close-on-backdrop
            hide-footer
            hide-header-close
          >
            <div class="p-4">
              <div class="expired mb-3 m-auto"></div>
              <h3 class="text-center">Votre session a expiré</h3>
              <p class="text-center text-muted lh-sm">
                Veuillez vous reconnecter pour accéder à l'application.
              </p>
              <div class="d-flex justify-content-center">
                <a class="btn btn-primary" href="#" @click="redirectToAuth()">
                  <span class="d-flex align-items-center">
                    <span class="fw-500">Reconnecter</span>
                    <i class="mdi mdi-arrow-right ms-2"></i>
                  </span>
                </a>
              </div>
            </div>
          </b-modal>
        </div>
        <div></div>
      </div>
      <Common />
    </div>
  </div>
</template>

<script>
import Common from "./components/Common";
import MainMenu from "./components/layouts/menu/MainMenu";
import MainHeader from "@/components/layouts/header/MainHeader";
import { subscriber } from "@/services/";
export default {
  name: "app",
  components: { MainMenu, MainHeader, Common },
  created: function () {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "session-modale") {
        $("body").addClass("session");
      }
    });
  },
  data: function () {
    return {
      session: this.utils_get_cookies("MUST"),
    };
  },
  async mounted() {
    var self = this;
    setInterval(function () {
      if (
        self.utils_get_cookies("MUST") == undefined ||
        self.utils_get_cookies("MUST") == null
      ) {
        self.$bvModal.show("session-modale");
      } else {
        return;
      }
    }, 600);
  },
  methods: {
    redirectToAuth() {
      this.redirect_to_auth();
    },
  },
  watch: {
    $route: {
      handler: (to) => {
        document.title = (to.meta.title ?? "Yello") + " | MyMTN Web" || "MyMTN Web";
      },
      immediate: true,
    },
    "$store.state.app_is_ready": async function (el) {
      $("#app_loader_wrap").fadeOut();
    },
    session() {
      if (this.session == null || this.session == undefined) {
      }
    },
  },
};
</script>
<style scoped>
.expired {
  background: url("./assets/svg/session-expired.svg") center local;
  background-size: 95%;
  background-repeat: no-repeat;
  height: 80px;
  width: 124px;
}
</style>